import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";

const faqs = [
    {
        q: "What happens after I reach out?",
        a: "We schedule a 30-min discovery call to scope your use case, then send a custom plan with timeline and price. From greenlight to working prototype is typically 3–7 days — not 3 months. You see the agent live, connected to your real tools, before you sign anything long-term.",
    },
    {
        q: "How is this different from hiring an AI agency?",
        a: "Most agencies charge $30k–$150k upfront on fixed scopes that go stale the moment your business shifts. We work as a flat-fee monthly retainer — your agent evolves with you, and you can pause or cancel any month.",
    },
    {
        q: "Which models and tools do you use?",
        a: "We route between GPT-5, Claude, and Gemini depending on the task — optimizing for accuracy and cost. We integrate natively with Stripe, HubSpot, Slack, Notion, Shopify, Zapier, and most modern SaaS tools via API.",
    },
    {
        q: "Do you only work with technical founders?",
        a: "Not at all. Roughly 70% of our clients are non-technical solopreneurs and small business owners. We handle the engineering — you just need to know what problem you want solved.",
    },
    {
        q: "Who owns the agent and the data?",
        a: "You do. Full IP ownership of the agent, the prompts, the integrations, and any training data. We host and maintain it as part of the retainer, but on cancellation you get a clean export.",
    },
    {
        q: "Can you build something other than an agent?",
        a: "Yes — web apps, internal tools, AI-powered landing pages, and dashboards are all in scope. If it has an LLM somewhere in the stack, we probably ship it.",
    },
];

export default function FAQ() {
    return (
        <section data-testid="faq-section" className="relative py-24 sm:py-32">
            <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-16">
                <div className="text-center mb-14">
                    <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#00f0ff]">
                        Honest answers
                    </span>
                    <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter mt-4 leading-[1.05]">
                        Questions, answered.
                    </h2>
                </div>

                <Accordion type="single" collapsible className="space-y-3">
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i + 1}`}
                            className="rounded-xl bg-[#0a1325] border border-white/10 px-6 data-[state=open]:border-[#00f0ff]/40 transition-colors"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i + 1}`}
                                className="text-left font-heading text-base sm:text-lg font-semibold text-white hover:no-underline py-5"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-[#94a3b8] leading-relaxed text-base pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
